import { render, staticRenderFns } from "./EmailConfirmationPrompt.vue?vue&type=template&id=27786bdf&scoped=true&"
import script from "./EmailConfirmationPrompt.vue?vue&type=script&lang=js&"
export * from "./EmailConfirmationPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27786bdf",
  null
  
)

export default component.exports